export default __webpack_public_path__ + "static/media/serviceflow.e16c19eb.svg";